import angular from 'angular';
import { react2angular } from 'react2angular';

import {
  SocialIcons,
  SocialIconsProps,
} from '../react/components/social-icons';

import {
  RequireConsent,
  RequireConsentProps,
} from '../react/components/subscribe';

angular
  .module('shoutout-regions', ['ng'])
  .component('socialIcons', react2angular(SocialIcons, SocialIconsProps as any))
  .component(
    'subscribeRequireConsent',
    react2angular(RequireConsent, RequireConsentProps as any),
  );
